import { 
  useState, 
  useEffect, 
  useMemo 
} from 'react'

const useColumnManager = (columns, storageKey, defaultColumns = []) => {
  // 1. Get all possible column IDs in their defined order
  const allColumnIds = useMemo(() => Object.keys(columns), [columns])

  // 2. Memoize mandatory columns so they don't re-calculate on every render
  const mandatoryColumns = useMemo(() => {
    return Object.values(columns)
      .filter(column => column.deselectable === false)
      .map(column => column.id)
  }, [columns])

  // 3. Initialize state
  const [selectedColumns, setSelectedColumns] = useState(() => {
    try {
      const rawStored = window.localStorage.getItem(storageKey)
      const stored = rawStored ? JSON.parse(rawStored) : defaultColumns
      
      // Combine stored and mandatory into a unique Set for quick lookup
      const selectionLookup = new Set([...mandatoryColumns, ...stored])

      // KEY CHANGE: Map through the original order and only keep items in the lookup
      return allColumnIds.filter(id => selectionLookup.has(id))
      
    } catch (error) {
      console.error("Error parsing stored columns:", error)
      const fallbackLookup = new Set([...mandatoryColumns, ...defaultColumns])
      return allColumnIds.filter(id => fallbackLookup.has(id))
    }
  })

  // 4. Keep LocalStorage in sync whenever state changes
  useEffect(() => {
    window.localStorage.setItem(storageKey, JSON.stringify(selectedColumns))
  }, [selectedColumns, storageKey])

  return [selectedColumns, setSelectedColumns]
}

export default useColumnManager